import React, { Component } from "react";

export class AddEditCustomers extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return <div></div>;
  }
}

export default AddEditCustomers;
